// "Max Lifestyle - Projects", "max lifestyle projects" and "MAX0" vs "MAXO" are all the same
// thing to a tired admin, so creating one of them warns about the other.
const normalise = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/0/g, "o")
    .replace(/[^a-z0-9]/g, "")
    .replace(/s$/, "");

export function nearMatch(name, code, customers) {
  const n = normalise(name);
  const c = normalise(code);
  return (
    customers.find((x) => (n && normalise(x.name) === n) || (c && normalise(x.code) === c)) || null
  );
}

export default nearMatch;
